export const TAGLINE_OPTIONS = [
  { label: "open to", value: "openTo" },
  { label: "interested in", value: "interestedIn" },
  { label: "hiring", value: "hiring" },
  { label: "looking for", value: "lookingFor" },
  { label: "feeling", value: "feeling" },
];

export const OPEN_TO_OPTIONS = [
  "collaboration",
  "accountability",
  "freelance",
];

export const INTERESTED_IN_OPTIONS = [
  "collaboration",
  "accountability",
  "freelance",
];

export const HIRING_OPTIONS = ["teammates", "freelancers"];

export const LOOKING_FOR_OPTIONS = [
  "collaboration",
  "clients",
  "coworking partners",
  "peace",
];

export const FEELING_OPTIONS = [
  "happy",
  "grateful",
  "blessed",
  "lucky",
  "thoughtful",
  "deep",
  "sad",
  "energetic",
];

export const TAGS_BY_TAGLINE_KEY = {
  openTo: OPEN_TO_OPTIONS,
  interestedIn: INTERESTED_IN_OPTIONS,
  hiring: HIRING_OPTIONS,
  lookingFor: LOOKING_FOR_OPTIONS,
  feeling: FEELING_OPTIONS,
};

export const taglineMap = Object.fromEntries(
  TAGLINE_OPTIONS.map(({ value, label }) => [value, label]),
);

export const humanizeTagline = (value) => {
  if (!value) return "";
  return taglineMap[value] || String(value).replace(/[_-]+/g, " ");
};
